{
  "(optional)": "(opţional)",
  "(required)": "(obligatoriu)"
}